var exports = {
  "vK": "x24da60e8--6d0b73--banner",
  "DD": "x24da60e8--6d0b73--title",
  "h_": "x24da60e8--6d0b73--description",
  "z6": "x24da60e8--6d0b73--agreement",
  "o1": "x24da60e8--6d0b73--actions",
  "Ju": "x24da60e8--6d0b73--accept",
  "Rm": "x24da60e8--6d0b73--secondary",
  "O1": "x24da60e8--6d0b73--timer",
  "WF": "x24da60e8--6d0b73--timer-progress",
  "fv": "x24da60e8--6d0b73--cookie-timer-progress",
};

module.exports = exports;
